// Centralized version type constants to avoid hardcoded strings across the app

export const VERSION_TYPES = {
  DRAFT: "draft",
  PRODUCTION: "production",
  BOTH: "both"
};

export const VERSION_TYPE_VALUES = Object.values(VERSION_TYPES);



